import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { GraduationCap } from 'lucide-react';
import { AICoachDrawer } from './AICoachDrawer';

interface CoachLauncherProps {
  mcqId: string;
  topic: string;
  stem: string;
  selectedOption: string;
  correctOption: string;
  explanation: string;
}

export const CoachLauncher = ({
  mcqId, topic, stem, selectedOption, correctOption, explanation
}: CoachLauncherProps) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        variant="outline"
        onClick={() => setOpen(true)}
        className="flex items-center gap-2 hover:bg-primary/5"
      >
        <GraduationCap className="h-4 w-4" />
        Coaching
      </Button>

      <AICoachDrawer
        open={open}
        onOpenChange={setOpen}
        mcqId={mcqId}
        topic={topic}
        stem={stem}
        selectedOption={selectedOption}
        correctOption={correctOption}
        explanation={explanation}
      />
    </>
  );
};
